import styled from "styled-components";

export const StyledListHeader = styled.div`
  display: flex;
`;

export const StyledListItemArea = styled.div`
  display: flex;
  width: 30vw;
`;

export const StyledModalHeader = styled.div`
  text-align: center;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 2rem 0;
  height: 100%;
  width: 100%;
  gap: 1rem;
`;
